import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "w-full overflow-hidden bg-background-bottom text-font-white py-[80px] flex flex-col items-center"
};
const _hoisted_2 = {
  class: "w-full flex items-start justify-center flex-wrap"
};
const _hoisted_3 = {
  class: "flex flex-col items-center"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-[20px] font-bold mb-[24px]"
}, "产品服务", -1);
const _hoisted_5 = {
  class: "flex items-start"
};
const _hoisted_6 = {
  class: "text-[18px] font-bold"
};
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "w-full h-[1px] bg-[#999999] my-[24px]"
}, null, -1);
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "flex flex-col items-center mx-[70px]"
};
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-[20px] font-bold mb-[36px]"
}, "联系我们", -1);
const _hoisted_11 = {
  class: "flex flex-col items-start"
};
const _hoisted_12 = {
  class: "flex items-center mb-[35px]"
};
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-[16px]"
}, "地址：福建省泉州市丰泽区宝洲街299号", -1);
const _hoisted_14 = {
  class: "flex items-center mb-[35px]"
};
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-[16px]"
}, "电话：0595-26653333", -1);
const _hoisted_16 = {
  class: "flex items-center mb-[35px]"
};
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-[16px]"
}, "邮箱：service@fjpszx.com", -1);
const _hoisted_18 = {
  class: "flex items-center mb-[35px]"
};
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-[16px]"
}, "工作日：周一到周五（8:30-18:00）", -1);
const _hoisted_20 = {
  class: "flex flex-col items-center"
};
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-[20px] font-bold mb-[36px]"
}, "品尚征信公众号", -1);
const _hoisted_22 = {
  class: "text-[16px] mt-[48px]"
};
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "版权所有：福建品尚征信有限公司  备案号：", -1);
import { getImage } from '@/hooks/global';
export default {
  __name: 'PsNavBottom',
  setup(__props) {
    const router = useRouter();
    const navList = markRaw([{
      title: '企业征信',
      list: [{
        text: '海丝征信链',
        path: 'https://mrc.psc.com.cn/'
      }, {
        text: '品尚查',
        path: '/PsSearchNewView'
      }, {
        text: '人行二代征信解析',
        path: '/CreditAnalysisView'
      }, {
        text: '数据API服务',
        path: '/ApiView'
      }, {
        text: '信用评价系统',
        path: '/CreditEvaluateView'
      }]
    }, {
      title: '两岸服务',
      list: [{
        text: '证照服务',
        path: '/ProductView?type=1'
      },
      // { text: '金融服务', path: '/ProductView?type=2' },
      {
        text: '生活服务',
        path: '/ProductView?type=3'
      }, {
        text: '创业服务',
        path: '/ProductView?type=4'
      }, {
        text: '征信服务',
        path: '/ProductView?type=5'
      }]
    },
    // { title: '金融服务', list: [
    // 	{ text: '小微企业金融服务', path: '/SmallEntServeView' },
    // 	{ text: '供应链金融服务', path: '/SupplyChainsView' },
    // 	{ text: '区块链金融服务', path: '/BlockChainsView' }
    // ] },
    {
      title: '政务服务',
      list: [{
        text: '数字化招商平台',
        path: '/DigitalInvestmentView'
      }, {
        text: '产业数智大脑',
        path: '/DigitalBrain'
      }, {
        text: '政策兑现综合服务平台',
        path: '/PolicyServicesView'
      }]
    }]);
    const jumpPage = path => {
      if (path.indexOf('http') !== -1) {
        window.open(path);
      } else {
        router.push(path);
      }
    };
    const openLink = url => {
      window.open(url);
    };
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navList), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "flex-1 flex flex-col items-start",
          key: index
        }, [_createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1), _hoisted_7, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (el, i) => {
          return _openBlock(), _createElementBlock("div", {
            class: "text-[16px] mb-[24px] mr-[32px] whitespace-nowrap cursor-pointer hover:underline",
            key: i,
            onClick: $event => jumpPage(el.path)
          }, _toDisplayString(el.text), 9, _hoisted_8);
        }), 128))]);
      }), 128))])]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_image, {
        class: "w-[24px] h-[24px] mr-[8px]",
        src: _unref(getImage)('/assets/navbarBottom/icon_address.png')
      }, null, 8, ["src"]), _hoisted_13]), _createElementVNode("div", _hoisted_14, [_createVNode(_component_el_image, {
        class: "w-[24px] h-[24px] mr-[8px]",
        src: _unref(getImage)('/assets/navbarBottom/icon_tel.png')
      }, null, 8, ["src"]), _hoisted_15]), _createElementVNode("div", _hoisted_16, [_createVNode(_component_el_image, {
        class: "w-[24px] h-[24px] mr-[8px]",
        src: _unref(getImage)('/assets/navbarBottom/icon_email.png')
      }, null, 8, ["src"]), _hoisted_17]), _createElementVNode("div", _hoisted_18, [_createVNode(_component_el_image, {
        class: "w-[24px] h-[24px] mr-[8px]",
        src: _unref(getImage)('/assets/navbarBottom/icon_workday.png')
      }, null, 8, ["src"]), _hoisted_19])])]), _createElementVNode("div", _hoisted_20, [_hoisted_21, _createVNode(_component_el_image, {
        class: "w-[203px] h-[203px]",
        src: _unref(getImage)('/assets/navbarBottom/qrcode.png')
      }, null, 8, ["src"])])]), _createElementVNode("div", _hoisted_22, [_hoisted_23, _createElementVNode("span", {
        class: "hover:underline cursor-pointer",
        onClick: _cache[0] || (_cache[0] = $event => openLink('https://beian.miit.gov.cn/#/Integrated/index'))
      }, "闽ICP备19005079号-1")])]);
    };
  }
};